import * as React from "react";
import "../TemplateDriven/dataMapTable.scss";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Grid, Box, Snackbar, Alert, AlertTitle } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditableCell from "./EditableCell";
import Label from "../../Label/Label";
import Buttons from "../../Controls/Buttons/Button";
import moment from "moment";
import {
  clearResetProDataFromPre,
  qcMapData,
  resetProDataFromPre,
  updateQcParametersData,
} from "../../../redux/pre_processor/actions";
import QCRowRejectAndReviewNew from "../TemplateDriven/QCRowRejectAndReviewNew";
import QCEditableCell from "./QCEditableCell";
import NewQuestion from "./NewQuestion";
import { logObject } from "../../../config/logs";
import RangeSelector from "../TemplateDriven/RangeSelector";
import DataTypeSelector from "../TemplateDriven/DataTypeSelector";
import CellMenu from "../TemplateDriven/CellMenu";
import { useRef } from "react";
import Validation from "../TemplateDriven/Validation";
import CustomizedSnackbars from "../../Snackbars/CustomizedSnackbars";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "#1A2027" : "var(--bg-white)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const PreProcessorQCTable = React.forwardRef((props, ref) => {
  const {
    selectedFile,
    // , qcTemplateData
    role,
    showParameterTable,
  } = props;

  // const roleMapping = {
  //   preProcessor: "prePro",
  //   processor: "pro",
  //   validator: "vali",
  // };

  // const initialParametersData = useSelector(
  //   (state) =>
  //     state?.prePro?.coorData?.qc_mapping_details?.parametersData || []
  // );

  // const useRejectionCounts = (role, rejectionType) => {
  //   const roleKey = roleMapping[role];

  //   return useSelector(
  //     (state) =>
  //       state?.[roleKey]?.coorData?.qc_mapping_details?.[
  //         `${rejectionType}RejectionCounts`
  //       ] || 0
  //   );
  // };

  const parametersData = useSelector(
    (state) => state?.prePro?.qcParametersData || []
  );
  const resetProDataFromPreResponse = useSelector(
    (state) => state?.prePro?.resetProDataFromPreResponse
  );

  const dispatch = useDispatch();
  const cellMenuRef = useRef(null);

  // const [parametersData, setParametersData] = useState([...qcTemplateData]);

  const anyOperationPerformedOnEntirePage = React.useRef(false);

  const [columnWidths, setColumnWidths] = useState({
    sr: 20,
    parameter: 315,
    input: 130,
    rejectionColumn: 80,
    dataType: 100,
    range: 90,
  });
  const isDataRejectedByProcessor = useSelector(
    (state) =>
      state?.prePro?.coorData?.qc_mapping_details?.isDataRejectedByProcessor
  );

  const isDataRejectedByValidator = useSelector(
    (state) =>
      state?.prePro?.coorData?.qc_mapping_details?.isDataRejectedByValidator
  );

  const entireBatchRejectedByPro = useSelector(
    (state) =>
      state?.prePro?.coorData?.qc_mapping_details?.entireBatchRejectedByPro
  );

  const coordinatesData = useSelector((state) => {
    return state?.prePro?.coorData?.coordinatesDetails;
  });

  // const [processorsRejectionCounts, setProcessorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "processors")
  // );

  // const [validatorsRejectionCounts, setValidatorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "validators")
  // );

  const [isAlert, setAlert] = useState({
    open: false,
    message: "",
    title: "",
  });

  const [isUpdateParameters, setIsUpdateParameters] = useState(false);

  //console.log(processorsRejectionCounts);

  const [logs, setLogs] = useState([]);

  // const [rowRejectionData, setRowRejectionData] = useState([]);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);

  // useEffect(() => {
  //   if (initialParametersData?.length > 0) {
  //     dispatch(updateQcParametersData(initialParametersData));
  //   }
  // }, [initialParametersData]);

  useEffect(() => {
    window.addEventListener("beforeunload", beforeunloadFunc);

    return () => {
      // Anything in here is fired on component unmount.
      window.removeEventListener("beforeunload", beforeunloadFunc);
    };
  }, []);

  useEffect(() => {
    if (
      resetProDataFromPreResponse &&
      resetProDataFromPreResponse !== undefined
    ) {
      if (resetProDataFromPreResponse?.apiError === true) {
        setErr(true);
        setMessage(resetProDataFromPreResponse?.message);
        dispatch(clearResetProDataFromPre());
      } else if (resetProDataFromPreResponse?.apiSuccess === true) {
        setSuccess(true);
        setMessage(resetProDataFromPreResponse?.message);
        dispatch(clearResetProDataFromPre());
        // Refresh the page on success
        // setTimeout(())
        // window.location.reload();
      }
    }
  }, [resetProDataFromPreResponse, dispatch]);

  React.useImperativeHandle(ref, () => ({
    mapData2: (action, next, autoSave) => {
      // dispatch(
      //   qcMapData({
      //     parametersData: parametersData,
      //     projectId: localStorage.projectId,
      //     // next: action === "save" ? false : true,
      //     next: next,
      //     autosave: autoSave,
      //     isUpdateParameters: isUpdateParameters,
      //     logs: [],
      //   })
      // );

      if (role === "preProcessor") {
        if (action === "saveAndNext") {
          // if (processorsRejectionCounts) {
          const rejectionFound = parametersData?.some((item) => {
            if (
              item?.mappings?.some(
                (mapping) =>
                  mapping?.processorCellRejection?.isRejected === true
              )
            ) {
              return true; // Stop iteration
            }
            // if (item?.processorRowRejection?.isRejected === true) {
            //   return true; // Stop iteration
            // }
            return false; // Continue checking other items
          });
          if (rejectionFound) {
            setAlert({
              ...isAlert,
              open: true,
              message:
                "Some rejection are not resolved. please resolve them before continue.",
              title: "Resolve Rejections",
            });
          } else {
            dispatch(
              qcMapData({
                parametersData: parametersData,
                projectId: localStorage.projectId,
                next: next,
                isUpdateParameters: isUpdateParameters,
                isDataRejectedByProcessor: false,
                ...(isDataRejectedByProcessor && {
                  reProcess: true,
                }),
                ...(isDataRejectedByValidator && {
                  isDataRejectedByValidator: true,
                }),
                entireBatchRejectedByPro: false,
                ...(entireBatchRejectedByPro && {
                  reProcessEntireBatch: true,
                }),
                logs: logs,
                // processorsRejectionCounts: processorsRejectionCounts,
                // validatorsRejectionCounts: validatorsRejectionCounts,
                autosave: autoSave,
              })
            );
          }
          // }
        } else if (action === "save") {
          dispatch(
            qcMapData({
              parametersData: parametersData,
              projectId: localStorage.projectId,
              next: next,
              isUpdateParameters: isUpdateParameters,
              ...(isDataRejectedByProcessor && {
                isDataRejectedByProcessor: true,
              }),
              ...(isDataRejectedByValidator && {
                isDataRejectedByValidator: true,
              }),
              ...(entireBatchRejectedByPro && {
                entireBatchRejectedByPro: true,
              }),
              logs: logs,
              // processorsRejectionCounts: processorsRejectionCounts,
              // validatorsRejectionCounts: validatorsRejectionCounts,
              autosave: autoSave,
              onSaveSuccess: () => {
                setLogs([]); // Clear logs after debugging
              },
            })
          );
          // setLogs([]); // clearing logs because if user click saveAndNext then also previous log will pass to api so to avoid duplication need to clear logs
        }
      }
    },
  }));

  // const callMapdata = () => {
  //   console.log("called ");
  // };

  const beforeunloadFunc = (e) => {
    if (anyOperationPerformedOnEntirePage.current) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  const onClickMapping = (e, parameterIndex) => {
    e.preventDefault();

    // Create a copy of parametersData
    let updatedParametersData = [...parametersData];
    let cellData = updatedParametersData[parameterIndex].mappings[0];

    const isChanged =
      cellData?.tagName !== selectedFile?.tagName ||
      parseInt(cellData?.pageNo) !== parseInt(selectedFile?.pageNo);

    cellData = {
      ...cellData,
      tagName: selectedFile?.tagName,
      pageNo: selectedFile?.pageNo,
      fileNo: selectedFile?.fileNo,
      preProcessor: localStorage?.userName,
      preProcessedDate: moment().format("DD-MMM-YYYY"),
      parameter_question:
        updatedParametersData[parameterIndex]?.parameter_question || "",
    };

    if (isChanged) {
      setTimeout(
        () =>
          cellMenuRef.current?.openParameterQuestionModal(
            updatedParametersData[parameterIndex]?.parameter_question || ""
          ),
        500
      );

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "qc_extraction",
          category: "mapping",
          action: "Question Mapped",
          parameter: parametersData[parameterIndex]?.query,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"] || "",
          rangeMax: parametersData[parameterIndex]?.range?.["max"] || "",
          // coordinates:
          //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
          // coordinatesValues:
          //   parametersData[parameterIndex]?.mappings[0]
          //     ?.coordinatesValues,
          tagName: selectedFile?.tagName,
          pageNo: selectedFile?.pageNo,
          fileNo: selectedFile?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            // , parseInt(mappingIndex) + 1
          ],
          mbrName: selectedFile?.originalFileName || "",
          document:
            coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
              ?.imageUrl,
        }),
      ]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: "mapping",
          action:
            // string === "valueMapping"
            //   ?
            "Context Added",
          // : "Add Parameter Key Mapping",
          parameter: parametersData[parameterIndex]?.query,
          remark: cellData?.parameter_question,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"] || "",
          rangeMax: parametersData[parameterIndex]?.range?.["max"] || "",
          // coordinates:
          //   // string === "valueMapping"
          //   //   ?
          //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
          // // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
          // //     ?.coordinates,
          // coordinatesValues:
          //   // string === "valueMapping"
          //   //   ?
          //   parametersData[parameterIndex]?.mappings[0]?.coordinatesValues,
          // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
          //     ?.coordinatesValues,

          tagName:
            // string === "valueMapping"
            //   ?
            parametersData[parameterIndex]?.mappings[0]?.tagName,
          // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
          //     ?.tagName,

          pageNo:
            // string === "valueMapping"
            //   ?
            parametersData[parameterIndex]?.mappings[0]?.pageNo,
          // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
          //     ?.pageNo,

          fileNo:
            // string === "valueMapping"
            //   ?
            parametersData[parameterIndex]?.mappings[0]?.fileNo,
          // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
          //     ?.fileNo,

          rowColIndex: [parseInt(parameterIndex) + 1, parseInt(0) + 1],
          mbrName: selectedFile?.originalFileName || "",
          document:
            coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
              ?.imageUrl,
        }),
      ]);
    }

    // if (
    //   cellData?.tagName &&
    //   parseInt(cellData?.pageNo) >= 0 &&
    //   (cellData?.tagName !== selectedFile?.tagName ||
    //     parseInt(cellData?.pageNo) !== parseInt(selectedFile?.pageNo))
    // ) {
    //   cellData = {
    //     ...cellData,
    //     tagName: selectedFile?.tagName,
    //     pageNo: selectedFile?.pageNo,
    //     fileNo: selectedFile?.fileNo,
    //     preProcessor: localStorage?.userName,
    //     preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //   };
    // } else {
    //   cellData = {
    //     ...cellData,
    //     tagName: selectedFile?.tagName,
    //     pageNo: selectedFile?.pageNo,
    //     fileNo: selectedFile?.fileNo,
    //     preProcessor: localStorage?.userName,
    //     preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //   };
    // }

    // Update the specific mapping within parametersData
    updatedParametersData[parameterIndex].mappings[0] = cellData;

    // Update the state
    // setParametersData(updatedParametersData);
    dispatch(updateQcParametersData([...updatedParametersData]));

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    // setLogs((prevLogs) => [
    //   ...prevLogs,
    //   logObject({
    //     extractionType: "qc_extraction",
    //     category: "mapping",
    //     action: "Question Mapping",
    //     parameter: parametersData[parameterIndex]?.query,
    //     // dataType: parametersData[parameterIndex]?.dataType,
    //     // rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //     // rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //     // coordinates:
    //     //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
    //     // coordinatesValues:
    //     //   parametersData[parameterIndex]?.mappings[mappingIndex]
    //     //     ?.coordinatesValues,
    //     tagName: selectedFile?.tagName,
    //     pageNo: selectedFile?.pageNo,
    //     fileNo: selectedFile?.fileNo,
    //     // rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
    //     mbrName: selectedFile?.originalFileName || "",
    //     // document:
    //     //   coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
    //     //     ?.imageUrl,
    //   }),
    // ]);
  };

  const clearMappings = (parameterIndex) => {
    let cellData = {
      ...parametersData[parameterIndex].mappings[0],
      tagName: "",
      pageNo: "",
      fileNo: "",
      preProcessor: localStorage.userName,
      preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    };

    cellData["lockedPreTagName"] = "";
    cellData["lockedPrePageNo"] = "";
    cellData["lockedPreFileNo"] = "";

    parametersData[parameterIndex].mappings[0] = cellData;
    dispatch(updateQcParametersData([...parametersData]));

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc_extraction",
        category: "mapping",
        action: "Question Mapping Cleared",
        parameter: parametersData[parameterIndex]?.query,
        // dataType: parametersData[parameterIndex]?.dataType,
        // rangeMin: parametersData[parameterIndex]?.range?.["min"],
        // rangeMax: parametersData[parameterIndex]?.range?.["max"],
        // coordinates: cellData?.coordinates,
        // coordinatesValues: cellData?.coordinatesValues,
        tagName: cellData?.tagName,
        pageNo: cellData?.pageNo,
        fileNo: cellData?.fileNo,
        rowColIndex: [
          parseInt(parameterIndex) + 1,
          // , parseInt(mappingIndex) + 1,
        ],
        // value:
        //   role === "processor"
        //     ? parametersData[parameterIndex].mappings[mappingIndex]?.value
        //     : role === "preProcessor"
        //     ? `${cellData?.tagName} - ${
        //         cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
        //       }`
        //     : "",
        mbrName: selectedFile?.originalFileName,
        document:
          role === "preProcessor"
            ? ""
            : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
                ?.imageUrl,
      }),
    ]);
  };

  const handleResize = (column, newWidth) => {
    setColumnWidths((prevWidths) => ({ ...prevWidths, [column]: newWidth }));
  };

  const handleMouseDown = (column) => (event) => {
    event.preventDefault(); // Prevent text selection during dragging

    const initialX = event.clientX;
    const initialWidth = columnWidths[column];

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - initialX;
      const newWidth = Math.max(25, initialWidth + deltaX); // Set a minimum width

      handleResize(column, newWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.classList.remove("resizing");
    };

    document.body.classList.add("resizing");

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const onClickResetButton = () => {
    const emptyData = [];
    parametersData?.map((parameterData) => {
      emptyData.push({
        query: parameterData?.query,
        parameter_question: parameterData?.parameter_question,
        question_index: parameterData?.question_index,
        response: "",
        mappings: [
          {
            value: "",
            tagName: "",
            pageNo: "",
            fileNo: "",
            preProcessor: "",
            preProcessedDate: "",
          },
        ],
      });
    });
    // setParametersData([...emptyData]);
    dispatch(updateQcParametersData([...emptyData]));

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "qc_extraction",
        category: "inputs",
        action: "Data Reset",
      }),
    ]);
  };

  const markAsResolveRejection = (parameterIndex, index) => {
    if (role === "preProcessor") {
      parametersData[parameterIndex].mappings[0].processorCellRejection = {
        isResolved: true,
        resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark:
          parametersData[parameterIndex].mappings[0].processorCellRejection
            ?.remark,
      };

      parametersData[parameterIndex].mappings[0].reInitiateOcr = true;

      // setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc_extraction",
        category: "mapping",
        action: "Rejection Resolved",
        parameter: parametersData[parameterIndex]?.query,
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setAlert({ ...isAlert, open: false, message: "", title: "" });
    }

    setAlert({ ...isAlert, open: false, message: "", title: "" });
  };

  const onClickProMappingResetButton = () => {
    dispatch(
      resetProDataFromPre(localStorage.projectId, localStorage.projectType)
    );

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "qc_extraction",
        category: "inputs",
        action: "Processor Mapping Reset ",
      }),
    ]);
  };

  const handleBlur = (text, parameterIndex, query) => {
    const updatedParametersData = [...parametersData];

    if (updatedParametersData[parameterIndex].query !== text) {
      updatedParametersData[parameterIndex].query = text;

      dispatch(updateQcParametersData([...updatedParametersData]));

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "qc_extraction",
          category: "mapping",
          action: `Question Name Updated`,
          parameter: query,
          value: text,
          rowColIndex: [parseInt(parameterIndex) + 1],
          dataType: updatedParametersData[parameterIndex]?.dataType,
          rangeMin: updatedParametersData[parameterIndex]?.range?.min,
          rangeMax: updatedParametersData[parameterIndex]?.range?.max,
        }),
      ]);
    }
  };

  const handleAddQuestion = (newQuestions) => {
    setIsUpdateParameters(true);
    // add new parameter in to old existed parametersData retrived from template

    const existingData = parametersData || [];

    const maxIndex = existingData.reduce(
      (max, item) => Math.max(max, item?.question_index || 0),
      0
    );

    const newData = newQuestions.map((q, i) => ({
      query: q?.question || "",
      question_index: maxIndex + i + 1,
      mappings: [
        {
          tagName: "",
          pageNo: "",
          fileNo: "",
          value: "",
          response: "",
        },
      ],
    }));

    dispatch(updateQcParametersData([...existingData, ...newData]));

    // for (let i = 0; i < newQuestions.length; i++) {
    //   parametersData.push({
    //     query: newQuestions[i]?.question,

    //     mappings: [
    //       {
    //         tagName: "",
    //         pageNo: "",
    //         fileNo: "",
    //         value: "",
    //         response: "",
    //       },
    //     ],
    //   });
    // }

    // dispatch(updateQcParametersData([...parametersData]));

    // delete new parameter after added in to table
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    let newQuestionDataInStringFormat = ``;
    newQuestions.forEach((item, index) => {
      newQuestionDataInStringFormat = `${newQuestionDataInStringFormat}${
        index > 0 ? ", " : ""
      }${index + 1}. Question: ${item?.question}`;
    });

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "qc_extraction",
        category: "inputs",
        action: "New Questions Added",
        data: newQuestionDataInStringFormat,
      }),
    ]);
  };

  const onHandleChangeDatatype = (dataType, parameter, parameterIndex) => {
    parametersData[parameterIndex].range = { min: "", max: "" };
    parametersData[parameterIndex].dataType = dataType;
    dispatch(updateQcParametersData([...parametersData]));

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc",
        category: "mapping",
        action: "Datatype Added",
        parameter: parametersData[parameterIndex]?.query,
        dataType: dataType,
      }),
    ]);
  };

  const handleRange = (value, parameterIndex, type) => {
    parametersData[parameterIndex].range[type] = value;
    dispatch(updateQcParametersData([...parametersData]));
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "qc",
        category: "mapping",
        action: "Range Added",
        parameter: parametersData[parameterIndex]?.query,
        ...(type === "min" ? { rangeMin: value } : { rangeMax: value }),
        dataType: parametersData[parameterIndex]?.dataType,
      }),
    ]);
  };

  const updateParameterQuestion = (question, parameterIndex, mappingIndex) => {
    if (
      parametersData[parameterIndex].mappings[mappingIndex]
        ?.parameter_question !== question
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        parameter_question: question,
      };
      // setParametersData([...parametersData]);
      dispatch(updateQcParametersData([...parametersData]));

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: role === "processor" ? "dataEntry" : "mapping",
          action: "Context Updated",
          parameter: parametersData[parameterIndex]?.query,
          rangeMin: parametersData[parameterIndex]?.range?.["min"] || "",
          rangeMax: parametersData[parameterIndex]?.range?.["max"] || "",
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          remark: question,
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
              )
            ]?.imageUrl,
          // ...(role === "processor"
          //   ? { processorRejected: true }
          //   : { validatorRejected: true }),
        }),
      ]);
    }
  };

  const handleDeleteModal = (parameterIndex, mappingIndex) => {
    if (
      parametersData[parameterIndex].mappings[mappingIndex]?.parameter_question
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        parameter_question: "",
      };
      // setParametersData([...parametersData]);
      dispatch(updateQcParametersData([...parametersData]));

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: role === "processor" ? "dataEntry" : "mapping",
          action: "Context Deleted",
          parameter: parametersData[parameterIndex]?.query,
          rangeMin: parametersData[parameterIndex]?.range?.["min"] || "",
          rangeMax: parametersData[parameterIndex]?.range?.["max"] || "",
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          remark: "",
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
              )
            ]?.imageUrl,
          // ...(role === "processor"
          //   ? { processorRejected: true }
          //   : { validatorRejected: true }),
        }),
      ]);
    }
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
    window.location.reload();
  };

  return (
    <Box>
      {showParameterTable === false && (
        <Box
        //  className="container-1" noValidate autoComplete="off"
        >
          <Box>
            <Grid container>
              {
                <Grid
                  Item
                  md={12}
                  className="addRow-dataMap"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <>
                    <NewQuestion
                      role={role}
                      handleAddQuestion={handleAddQuestion}
                    />

                    <Buttons
                      onClick={onClickProMappingResetButton}
                      className="reset-data"
                      text="Reset Processor Mappings"
                      variant="outlined"
                      size="small"
                    />

                    <Buttons
                      onClick={onClickResetButton}
                      className="reset-data"
                      text="Reset Data"
                      variant="outlined"
                      size="small"
                    />
                  </>
                </Grid>
                // )
              }
            </Grid>

            {/* <div
              style={{
                overflow: "scroll",
              }}
            > */}
              <Grid
                container
                className={
                  // role === "preProcessor"
                  //   ?
                  // "prePocessor DataMapTable-wrap"
                  "DataMapTable-wrap"
                  // : role === "processor"
                  // ? "prePocessor DataMapTable-wrap"
                  // : "DataMapTable-wrap"
                }
                style={{ width: "100%" }}
              >
                {/*heading block  */}
                <Grid item className="table-row">
                  <Item
                    className="DataMap-header table-cell resizable"
                    style={{
                      width: columnWidths.sr,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onMouseDown={handleMouseDown("sr")}
                  >
                    <Label text="Sr."></Label>
                  </Item>

                  <Item
                    className="DataMap-header table-cell resizable"
                    style={{
                      width: columnWidths.parameter,
                      // width: "-webkit-fill-available",

                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onMouseDown={handleMouseDown("parameter")}
                  >
                    <Label text="Parameters" />
                  </Item>

                  <Item
                    className="datatype-wrap table-cell resizable"
                    style={{
                      width: columnWidths.dataType,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onMouseDown={handleMouseDown("dataType")}
                  >
                    <Label text="Data Type">Data Type</Label>
                  </Item>

                  <Item
                    className="rangeSelect-wrap table-cell resizable"
                    style={{
                      width: columnWidths.range,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onMouseDown={handleMouseDown("range")}
                  >
                    <Label text="Range" />
                  </Item>

                  <Item
                    className={`DataMap-header table-cell resizable `}
                    style={{
                      width: columnWidths.input,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onMouseDown={handleMouseDown(`input`)}
                  >
                    <Label text="Input" />
                  </Item>

                  {/* 1st Checkbox in Pre processor after rejected by processor */}
                  {role === "preProcessor" && isDataRejectedByProcessor && (
                    <Item
                      // id="Pro-rej"
                      className={`DataMap-header table-cell resizable `}
                      style={{
                        width: columnWidths.rejectionColumn,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Label text="Rejected By Processor" padding="0px"></Label>
                    </Item>
                  )}
                </Grid>
                {parametersData?.map((parameterData, parameterIndex) => (
                  <>
                    <Grid Item className="DataMapTable" key={parameterIndex}>
                      <Item style={{ width: columnWidths.sr }}>
                        {parameterIndex + 1}
                      </Item>

                      <Item
                        style={{
                          width: columnWidths.parameter,
                          // width: "-webkit-fill-available",
                        }}
                      >
                        {/* <TextField
                          // inputProps={{ readOnly: true }}
                          className="parameters-name"
                          multiline
                          id="standard-basic"
                          variant="standard"
                          placeholder={parameterData?.query}
                          // value={parameterData?.query}
                          onBlur={(event) => handleBlur(event, parameterIndex)}

                          // readOnly
                        /> */}
                        <QCEditableCell
                          query={parameterData?.query}
                          parameterIndex={parameterIndex}
                          handleBlur={handleBlur}
                          role={role}
                        />
                      </Item>
                      <Item
                        className="datatype-wrap-selector "
                        style={{ width: columnWidths.dataType }}
                      >
                        <DataTypeSelector
                          parameterData={parameterData}
                          onHandleChangeDatatype={onHandleChangeDatatype}
                          parameterIndex={parameterIndex}
                          isDataRejectedByProcessor={isDataRejectedByProcessor}
                          role={role}
                          entireBatchRejectedByPro={entireBatchRejectedByPro}
                        />
                      </Item>

                      <Item
                        className="range-selector "
                        style={{ width: columnWidths.range }}
                      >
                        <RangeSelector
                          key={`${parameterIndex}_${parameterData.query}_${
                            parameterData?.range?.min || ""
                          }_${parameterData?.range?.max || ""}`}
                          handleRange={handleRange}
                          parameterIndex={parameterIndex}
                          dataType={parameterData?.dataType}
                          selectedRange={parameterData?.range}
                          role={role}
                          entireBatchRejectedByPro={entireBatchRejectedByPro}
                          parameterData={parameterData}
                          isDataRejectedByProcessor={isDataRejectedByProcessor}
                        />
                      </Item>

                      <Item
                        className="datatype-wrap"
                        sx={
                          role !== "preProcessor" && {
                            ...(Validation(
                              parametersData[parameterIndex]?.dataType,
                              parametersData[parameterIndex]?.range,
                              parameterData?.mappings[0]?.value
                            )?.error && {
                              border: "2px solid!important",
                              borderRadius: "5px!important",
                              borderColor: "#ff9800!important",
                            }),
                          }
                        }
                        style={{ width: columnWidths?.input }}
                      >
                        <EditableCell
                          parameterIndex={parameterIndex}
                          mapping={parameterData?.mappings[0]}
                          onClickMapping={onClickMapping}
                          clearMappings={clearMappings}
                          parametersData={parametersData}
                          mappingIndex={0}
                          // rowRejectionData={rowRejectionData}
                          isDataRejectedByProcessor={isDataRejectedByProcessor}
                          entireBatchRejectedByPro={entireBatchRejectedByPro}
                          // entireBatchRejectedByVali={entireBatchRejectedByVali}
                          // reProcessEntireBatch={reProcessEntireBatch}
                          // reProcess={reProcess}
                          // isDataRejectedByValidator={isDataRejectedByValidator}
                          // reValidate={reValidate}
                        />

                        {
                          // role === "preProcessor" &&
                          // (parameterData?.mappings[0]?.processorCellRejection
                          //   ?.isRejected === true ||
                          //   (parameterData?.mappings[0]?.pageNo >= 0 &&
                          //     parameterData?.mappings[0]?.tagName &&
                          //     (parameterData?.mappings[0]?.parameter_question ||
                          //       parameterData?.mappings[0]
                          //         ?.parameter_question === ""))) && (
                          //          ||
                          // role === "processor" ||
                          // role === "validator"
                          <CellMenu
                            parameter_question={
                              parameterData?.mappings[0]?.parameter_question
                            }
                            updateParameterQuestion={(question) =>
                              updateParameterQuestion(
                                question,
                                parameterIndex,
                                0
                              )
                            }
                            // isRejectedByProcessor={
                            //   parameterData?.mappings[0]?.processorCellRejection
                            //     ?.isRejected
                            // }
                            // processorRejectionRemark={
                            //   parameterData?.mappings[0]?.processorCellRejection
                            //     ?.remark
                            // }
                            // isRejectedByValidator={
                            //   parameterData?.mappings[0]?.validatorCellRejection
                            //     ?.isRejected
                            // }
                            // validatorRejectionRemark={
                            //   parameterData?.mappings[0]?.validatorCellRejection
                            //     ?.remark
                            // }
                            // rejectCell={(rejectionRemark) =>
                            //   rejectCell(
                            //     rejectionRemark,
                            //     parameterIndex,
                            //     mappingIndex
                            //   )
                            // }
                            // deleteRejection={() =>
                            //   deleteRejection(parameterIndex, mappingIndex)
                            // }
                            role={role}
                            // markAsResolveByProcessor={() =>
                            //   markAsResolveByProcessor(
                            //     parameterIndex,
                            //     mappingIndex
                            //   )
                            // }
                            // isRwoValidated={
                            //   parameterData?.rowValidation?.isValidated
                            // }
                            // heading={
                            //   role === "preProcessor"
                            //     ? action.REJECTION_REMARK
                            //     : action.REJECTION_PROMPT
                            // }
                            // isResolvedProcessorCellRejection={
                            //   parameterData?.mappings[0]?.processorCellRejection
                            //     ?.isResolved
                            // }
                            // isResolvedValidatorCellRejection={
                            //   parameterData?.mappings[0]?.validatorCellRejection
                            //     ?.isResolved
                            // }
                            // reInitiateProVlm={
                            //   parameterData?.mappings[0]?.reInitiateProVlm
                            // }
                            // handleChangeReProcess={(type) =>
                            //   handleChangeReProcess(
                            //     type,
                            //     parameterIndex,
                            //     mappingIndex
                            //   )
                            // }
                            // processorsRejectionCounts={
                            //   processorsRejectionCounts
                            // }
                            // reProcessVlmCounts={reProcessVlmCounts}
                            ref={cellMenuRef} // new for qc context to auto open on mapping
                            showMenuButton={
                              parameterData?.mappings[0]?.processorCellRejection
                                ?.isRejected === true ||
                              (parameterData?.mappings[0]?.pageNo >= 0 &&
                              parameterData?.mappings[0]?.tagName &&
                              (parameterData?.mappings[0]?.parameter_question ||
                                parameterData?.mappings[0]
                                  ?.parameter_question === "")
                                ? true
                                : false)
                            } // new prop as in qc pre we want to assign ref so we need to open bydefault this component
                            handleDeleteModal={() =>
                              handleDeleteModal(parameterIndex, 0)
                            }
                            isShowDeleteButton={true}
                          />
                          // )
                        }
                      </Item>

                      {/* 1st Checkbox in Pre processor after rejected by processor */}
                      {isDataRejectedByProcessor && (
                        <Item
                          className="reject-cell"
                          sx={{
                            width: `${columnWidths?.rejectionColumn}px !important`,
                          }}
                        >
                          <QCRowRejectAndReviewNew
                            parameterData={parameterData}
                            role={role}
                            isReadOnly={true}
                            isDataRejectedByProcessor
                            markAsResolveRejection={markAsResolveRejection}
                            parameterIndex={parameterIndex}
                            heading={"Row Rejection Remark."}
                          />
                        </Item>
                      )}
                    </Grid>
                  </>
                ))}
              </Grid>
            {/* </div> */}
          </Box>
        </Box>
      )}

      {isAlert?.open && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          key={"topcenter"}
        >
          <Alert onClose={handleClose} className="error-alert" severity="error">
            <AlertTitle color="white">{isAlert?.title}</AlertTitle>
            {isAlert?.message}
          </Alert>
        </Snackbar>
      )}

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => handleCloseSuccess()}
        />
      )}

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </Box>
  );
});
